import { useState, useEffect } from "react";
import axios from "axios";
import { getParams } from "./getParams";

// const black1Config = {
//   "scale_factor": 0.32822074367520495,
//   "front_back_correct": false,
//   "rotation": {
//     "x": -89.79133689040785,
//     "y": 269.87896360739603,
//     "z": 0.2412265142457883
//   },
//   "position": {
//     "x": 0.0,
//     "y": 0.22710433638553532,
//     "z": 0.0
//   },
//   "torus_config": {
//       "camera_center": [
//           0,
//           0,
//           0.012201565855066293
//       ],
//       "torus_inner_radius": 1.3149656319823608,
//       "torus_ring_radius": 0.3287414079955902
//   }
// }

// const black2Config = {
//   "scale_factor": 0.34161172687442387,
//   "front_back_correct": false,
//   "rotation": {
//         "x": -89.6256372784669,
//         "y": 269.8988406074396,
//         "z": 0.38778984157738106
//       },
//   "position": {
//         "x": 0.0,
//         "y": 0.2587605322306778,
//         "z": 0.0
//       },
//   "torus_config": {
//       "camera_center": [
//           0,
//           0,
//           0.05693787912372499
//       ],
//       "torus_inner_radius": 1.3716322736703672,
//       "torus_ring_radius": 0.3429080684175918
//   }
// }

// const black3Config = {
//   "scale_factor": 0.2373684459237867,
//   "front_back_correct": false,
//   "rotation": {
//         "x": -89.80558403042541,
//         "y": 269.5144558590077,
//         "z": 0.5230224581767962
//       },
//   "position": {
//         "x": 0.0,
//         "y": 0.20769739334221005,
//         "z": 0.0
//       },
//   "torus_config": {
//       "camera_center": [
//           0,
//           0,
//           0.04640656120842322
//       ],
//       "torus_inner_radius": 1.034426989155525,
//       "torus_ring_radius": 0.2586067472888812
//   }
// }

// const black4Config = {
//   "scale_factor": 0.34721860102486635,
//   "front_back_correct": false,
//   "rotation": {
//     "x": -89.42300131194663,
//     "y": 269.94403258363775,
//     "z": 0.5797068651469123
//   },
//   "position":  {
//     "x": 0.0,
//     "y": 0.25960169144404494,
//     "z": 0.0
//   },
//   "torus_config": {
//       "camera_center": [
//           0,
//           0,
//           0.034223686438053846
//       ],
//       "torus_inner_radius": 1.3978263662988792,
//       "torus_ring_radius": 0.3494565915747198
//   }
// }

const useSkuDetails = () => {
  const [skuName, setSkuName] = useState("");
  const [thumbnail, setThumbnail] = useState("/assets/images/sample_car.png");
  const [skuId, setSkuId] = useState("");
  const [enterpriseId, setEnterpriseId] = useState("");
  const [teamId, setTeamId] = useState("");
  const [year, setYear] = useState("");
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [urls, setUrls] = useState([]);
  const [name, setName] = useState("");
  const [modelConfig, setModelConfig] = useState(null);
  const [testingConfig, setTestingConfig] = useState(null);
  const [status, setStatus] = useState(null);
  const [bgId, setBgId] = useState(null); 

 
  useEffect(()=>{
    if(make || model){
      setName(`${year} ${make} ${model}`);
    }else{
      setName(skuName);
    }  },[year, make, model, skuName])

  const getSkuDetails = async () => {
    try {
      const params = getParams();
      const res = await axios.get(`${process.env.REACT_APP_BASEURL_API_SPYNE}/3d/api/v2/sku/getById`, params);
      setSkuName(res?.data?.sku_name);
      res?.data?.thumbnail ? setThumbnail(res?.data?.thumbnail) : setThumbnail('/assets/images/sample_car.png');
      setSkuId(res?.data?.sku_id);
      setEnterpriseId(res?.data?.enterprise_id);
      setTeamId(res?.data?.team_id);
      setUrls(res?.data?.inputVideoUrl);
      setStatus(res?.data?.status);
      // Set the model configuration
      if (res?.data?.config_details?.model_config) {
        setModelConfig(res.data.config_details.model_config);
      }
      if(res?.data?.config_details?.testingConfig){
        setTestingConfig(res?.data?.config_details?.testingConfig);
      }
      // setModelConfig(black4Config);
      setBgId(res?.data?.bg_id);
    } catch (error) {
      console.error("Error fetching SKU details:", error);
    }
  
  };
  const getVinDetails = async () => {
    if (enterpriseId && teamId && skuName) {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BASEURL_API_SPYNE}/inventory/v2/vins/details?enterpriseId=${enterpriseId}&teamId=${teamId}&vin=${skuName}`)
        setYear(res?.data?.data?.year);
        setMake(res?.data?.data?.make);
        setModel(res?.data?.data?.model);
      } catch (error) {
        console.error("Error fetching VIN details:", error);
      }
    }
  };

  useEffect(() => {
    setLoaded(false);
    getSkuDetails().then(()=>{
      if(enterpriseId && teamId && skuName){
        getVinDetails()
      }
    }).finally(()=>{
      setLoaded(true);
    });
  }, []);

  useEffect(() => {
    if(enterpriseId && teamId && skuName) {
      getVinDetails();
    }
  }, [enterpriseId, teamId, skuName]);

  return { thumbnail, skuId, loaded, urls, carName: name, modelConfig, status, bgId, skuName, enterpriseId, teamId, year, make, model, testingConfig };
};
export default useSkuDetails;